import React from "react";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import { motion } from "framer-motion";
import FuseLoading from "@fuse/core/FuseLoading";
import LocalListItem from "./LocalListItem";
import { useDispatch, useSelector } from "react-redux";
import {
  selectLocal,
  getLocalsAdmin,
} from "../../localAdmin/store/localAdminSlice";
import {
  selectEmpAdmin,
  getEmpAdmins,
} from "../../empAdmin/store/empAdminSlice";

export default function LocalList() {
  const dispatch = useDispatch();
  const locals = useSelector(selectLocal);
  const empAdmins = useSelector(selectEmpAdmin);

  React.useEffect(() => {
    dispatch(getLocalsAdmin());
    dispatch(getEmpAdmins());
  }, [dispatch]);

  if (!locals) {
    return <FuseLoading />;
  }

  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1, transition: { delay: 0.2 } }}
      className="flex flex-col flex-auto w-full max-h-full"
    >
      {locals.map((local, key) => {
        return (
          <div key={key} className="relative">
            <Divider />
            <List className="w-full m-0 p-0">
              <LocalListItem
                key={local.id}
                local={local}
                empAdmin={empAdmins}
              />
            </List>
          </div>
        );
      })}
    </motion.div>
  );
}
